<div
    class="block--content block"
    *ngIf="!env.ONDEMAND?.PAYMENT_ON_WEB || (env.ONDEMAND?.PAYMENT_ON_WEB && (cart$ | async).shopping_cart_id)">
    <div class="block--wrap well well--collapsing container block">
        <rwidget-alert></rwidget-alert>
    </div>

    <div class="ticket">
        <ridango-page-content-wrapper>
            <div class="intro-text remove-padding">
                <h1 class="title">{{ 'BOOKING_AWAITING_CONFIRMATION' | translate }}</h1>
                <p>{{ 'BOOKING_AWAITING_CONFIRMATION_DESCRIPTION' | translate }}</p>
                <h2>{{ 'PENDING_BOOKING' | translate }}</h2>
            </div>

            <rwidget-booking-ticket
                [plan]="plan"
                [passengerPermission]="passengerPermission$ | async"
                [specification]="specification"
                [estimatedPrice]="estimatedPrice"
                [isPending]="true"
                [dateFormat]="dateFormat"
                [label]="'BOOKINGS_PAGE_LABEL_PENDING_BOOKINGS' | translate"
                [customerProfile]="profile$ | async">
            </rwidget-booking-ticket>

            <!-- New flow does not currently support adding more than one booking at a time -->
            <!-- <div class="block block--wrap margin-top-20">
                <div class="summary-module-area">
                    <div class="summary-module-area__btn">
                        <button class="btn btn--maximal btn--primary margin-right-20 margin-bottom-10" (click)="bookReturnRide()">
                            {{ 'BOOK_RETURN_RIDE' | translate }}
                        </button>
                        <button class="btn btn--maximal btn--primary" (click)="bookAnotherRide()">
                            {{ 'BOOK_ANOTHER_RIDE' | translate }}
                        </button>
                    </div>
                </div>
            </div> -->

            <!-- payment -->
            <div *ngIf="env.ONDEMAND?.PAYMENT_ON_WEB && (cart$ | async).shopping_cart_id">
                <ridango-arrow-down-separator></ridango-arrow-down-separator>
                <rwidget-cart-payment-methods></rwidget-cart-payment-methods>
                <ridango-arrow-down-separator></ridango-arrow-down-separator>
            </div>
        </ridango-page-content-wrapper>
    </div>

    <div class="block--bg-wrapper ticket-summary" *ngIf="(cart$ | async).shopping_cart_id">
        <rwidget-cart-summary></rwidget-cart-summary>
    </div>
</div>

<rwidget-navigate-away-modal
    [showNavigationModal]="showNavigationModal"
    [translations]="modalTranslations"
    (onConfirmNavigation)="onConfirmNavigationModal()"
    (onCancelNavigation)="onCloseNavigationModal()"></rwidget-navigate-away-modal>
